<div *ngFor="let alert of alerts" class="{{cssClass(alert)}}">
    <span [innerHTML]="alert.message"></span>
    <button class="btn-close" (click)="removeAlert(alert)"></button>
</div>